import { useQuery } from "@tanstack/react-query";

import { getExternalServiceAssignee } from "../services/externalServiceAssignee";

export const useExternalServiceAssignee = (entity: string, id: string) => {
  const get = async () => {
    const response = await getExternalServiceAssignee(entity, id);
    return response;
  };

  const { data } = useQuery({
    queryFn: get,
    queryKey: ["externalServiceAssignee", entity, id],
  });

  return {
    data,
  };
};
